import * as React from "react";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { Gender } from "../../../../../../../Wrap/Constants/Enums/Domain/Gender";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../Urls";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { TaxReferenceType } from "../../../../../../../Wrap/Constants/Enums/Customer/TaxReferenceType";
import { CountryCodeMap } from "../../../../../../Shared/Entities/Maps/CountryCodeMap";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { StepReview } from "./StepReview";
import { FullClientDetailClient } from "../../../../../../../Wrap/Api/Customer/FullClientDetail";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { BWACheck } from "../../../Common/Review/Component/BWACheck";

interface IReviewProps extends IProcessComponentProps {
    data: ApplyModel;
}

interface IReviewState {
    selectedClientInfo: FullClientDetailModel;
}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = { selectedClientInfo: null };
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.data.SecondClientDetails?.ActorId) {
            const client = new FullClientDetailClient();
            const promise = client.get(this.props.data.SecondClientDetails.ActorId);
            promise.onSuccess((result) => {
                this.setState({ selectedClientInfo: result });
            });
        }
    }
    private clientDetailRender() {
        const data = this.props.data.ClientDetails;
        const nino = data?.TaxResidency?.find(
            (e: CustomerTaxResidencyModel) => e.TaxReferenceType == TaxReferenceType.GbrNino
        );
        const ninoSecond = this.state.selectedClientInfo?.CustomerTaxResidencyDetails?.find(
            (e: CustomerTaxResidencyModel) => e.TaxReferenceType == TaxReferenceType.GbrNino
        );
        let nationality = "";
        let taxResidency = "";
        if (data.TaxResidency && data.TaxResidency.length > 0) {
            //UK is always tax resident for now
            const taxResidentList = data.TaxResidency.filter((x) => x.IsTaxResident);

            if (taxResidentList.length == 1) {
                taxResidency = `${CountryCodeMap.getString(taxResidentList[0].Country)} only`;
            } else {
                taxResidentList.map((ele) => {
                    taxResidency += `${CountryCodeMap.getString(ele.Country)}, `;
                });
                taxResidency = taxResidency.substring(0, taxResidency.length - 2);
            }

            const nationalityList = data.TaxResidency.filter((x) => x.IsNationality);
            if (nationalityList.length == 1) {
                nationality = `${CountryCodeMap.getString(data.TaxResidency[0].Country)} only`;
            } else if (nationalityList.length > 1) {
                nationalityList.map((ele) => {
                    nationality += `${CountryCodeMap.getString(ele.Country)}, `;
                });
                nationality = nationality.substring(0, nationality.length - 2);
            }
        }

        let nationality2 = "";
        let taxResidency2 = "";
        if (
            this.state.selectedClientInfo?.CustomerTaxResidencyDetails &&
            this.state.selectedClientInfo?.CustomerTaxResidencyDetails?.length > 0
        ) {
            //UK is always tax resident for now
            const taxResidentList = this.state.selectedClientInfo?.CustomerTaxResidencyDetails?.filter(
                (x) => x.IsTaxResident
            );

            if (taxResidentList.length == 1) {
                taxResidency2 = `${CountryCodeMap.getString(taxResidentList[0].Country)} only`;
            } else {
                taxResidentList.map((ele) => {
                    taxResidency2 += `${CountryCodeMap.getString(ele.Country)}, `;
                });
                taxResidency2 = taxResidency2?.substring(0, taxResidency2.length - 2);
            }

            const nationalityList = this.state.selectedClientInfo?.CustomerTaxResidencyDetails?.filter(
                (x) => x.IsNationality
            );
            if (nationalityList.length == 1) {
                nationality2 = `${CountryCodeMap.getString(
                    this.state.selectedClientInfo?.CustomerTaxResidencyDetails[0]?.Country
                )} only`;
            } else if (nationalityList.length > 1) {
                nationalityList.map((ele) => {
                    nationality2 += `${CountryCodeMap.getString(ele.Country)}, `;
                });
                nationality2 = nationality2.substring(0, nationality2.length - 2);
            }
        }
        let caption = "Joint account holder ";
        if (this.props.data.IsJointAccount) {
            caption = caption + " 1";
        }

        const config = [
            {
                title: caption,
                data: this.props.data.IsJointAccount ? " " : "",
            },
            {
                title: "Title",
                data: TitleMap.getString(data.Title),
            },
            {
                title: "Name",
                data: `${data.FirstName} ${data.LastName}`,
            },
            {
                title: "Gender",
                data: data.Gender == Gender.Female ? "Female" : "Male",
            },
            {
                title: "Date of birth",
                data: JsonDateParser.getFormatDate(data.DateOfBirth, "dd/MM/yyyy"),
            },
            {
                title: "NINO",
                data: nino?.TaxReference,
            },
            {
                title: "Country of nationality",
                data: nationality,
            },
            {
                title: "Tax residency",
                data: taxResidency,
            },
            {
                title: "Financial advice",
                data: this.props.data.AdviceGiven ? "Yes" : "No",
            },
        ];
        const config1 = [
            {
                title: "Joint account holder 2",
                data: " ",
            },
            {
                title: "Title",
                data: TitleMap.getString(this.state.selectedClientInfo?.PersonalDetails?.Title),
            },
            {
                title: "Name",
                data: `${this.state.selectedClientInfo?.PersonalDetails?.GivenName} ${this.state.selectedClientInfo?.PersonalDetails?.FamilyName}`,
            },
            {
                title: "Gender",
                data: this.state.selectedClientInfo?.PersonalDetails?.Gender == Gender.Female ? "Female" : "Male",
            },
            {
                title: "Date of birth",
                data: JsonDateParser.getFormatDate(
                    this.state.selectedClientInfo?.PersonalDetails?.DateOfBirth,
                    "dd/MM/yyyy"
                ),
            },
            {
                title: "NINO",
                data: ninoSecond?.TaxReference,
            },
            {
                title: "Country of nationality",
                data: nationality2,
            },
            {
                title: "Tax residency",
                data: taxResidency2,
            },
            {
                title: "Financial advice",
                data: this.props.data.AdviceGiven ? "Yes" : "No",
            },
        ];
        return (
            <div>
                <div className="d-flex flex-space">
                    <h2 className="mb-11">Full client details</h2>
                    <button
                        className="edit-circle-icon-button label-sr-only"
                        title="Edit"
                        onClick={() => Navigator.navigateToAndPreserveQueryParameters(Urls.get().FullClientDetail)}
                    >
                        <span className="icon" aria-hidden="true"></span>
                        <span className="text">Edit</span>
                    </button>
                </div>

                <hr className="heading-underlined-keyline"></hr>
                <Typography type="common" config={config}></Typography>

                {this.props.data.IsJointAccount &&
                    this.props.data.SecondClientDetails != null &&
                    this.state.selectedClientInfo && (
                        <>
                            <hr className="heading-underlined-keyline"></hr>
                            <Typography type="common" config={config1}></Typography>
                        </>
                    )}
            </div>

            // <Accordion
            //     label="Full client details"
            //     onEdit={() => Navigator.navigateToAndPreserveQueryParameters(Urls.get().FullClientDetail)}
            //     isOpen={true}
            // >
            //     <Typography type="vertical" colNum={2} config={config} />
            // </Accordion>

            // Shouldn't be expandable
        );
    }

    private getStepReviewProps = (key) => {
        return {
            data: this.props.data[key],
            model: this.props.data,
        };
    };

    render() {
        const selectedProducts = this.props.data.SelectedProducts;
        const pensionDetail = selectedProducts.find((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        const isaDetail = selectedProducts.find((ele) => SubAccountTypeHelper.isIsa(ele.SubAccountType));
        const ppDetail = selectedProducts.find((ele) => SubAccountTypeHelper.isPP(ele.SubAccountType));
        const wrapCashDetail = selectedProducts.find((ele) => SubAccountTypeHelper.isWrapCash(ele.SubAccountType));

        return (
            <>
                <h2 className="mb-24">Review</h2>
                <BWACheck extraInfo={this.props.data} />
                {this.clientDetailRender()}
                {pensionDetail && (
                    <div className="mb-40">
                        {isaDetail || ppDetail || wrapCashDetail ? <h2>SIPP details</h2> : null}
                        <StepReview
                            {...this.getStepReviewProps("PensionApply")}
                            subAccountType={pensionDetail.SubAccountType}
                        />
                    </div>
                )}
                {isaDetail && (
                    <div className="mb-40">
                        {pensionDetail || ppDetail || wrapCashDetail ? <h2>ISA details</h2> : null}
                        <StepReview
                            {...this.getStepReviewProps("IsaModel")}
                            subAccountType={isaDetail.SubAccountType}
                        />
                    </div>
                )}
                {ppDetail && (
                    <div className="mb-40">
                        {pensionDetail || isaDetail || wrapCashDetail ? <h2>Personal Portfolio details</h2> : null}
                        <StepReview {...this.getStepReviewProps("GiaModel")} subAccountType={ppDetail.SubAccountType} />
                    </div>
                )}
                {wrapCashDetail && (
                    <>
                        <h2>Cash Account details</h2>
                        <StepReview
                            {...this.getStepReviewProps("WrapCashModel")}
                            subAccountType={wrapCashDetail.SubAccountType}
                        />
                    </>
                )}
            </>
        );
    }
}
